<ng-container [ngSwitch]="layout">
    <!-- Alternativerly use the main layout as the default switch case -->
    <public-layout *ngSwitchCase="Layouts.Public"></public-layout>
    <admin-layout *ngSwitchCase="Layouts.Admin"></admin-layout>
</ng-container>